import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { CustomViewsModule } from '../custom-views/custom-views.module';
import { OrderColumnComponent } from './components/order-column/order-column.component';
import { QuoteColumnComponent } from './components/quote-column/quote-column.component';
import { OrderLocationColumnComponent } from './order-location-column/order-location-column.component';
import { OrderProfitColumnComponent } from './order-profit-column/order-profit-column.component';
import { OrderShipperColumnComponent } from './order-shipper-column/order-shipper-column.component';
import { OrderTrailerColumnComponent } from './order-trailer-column/order-trailer-column.component';

@NgModule({
  declarations: [
    OrderLocationColumnComponent,
    OrderShipperColumnComponent,
    OrderTrailerColumnComponent,
    OrderProfitColumnComponent,
    OrderColumnComponent,
    QuoteColumnComponent,
  ],
  exports: [
    OrderLocationColumnComponent,
    OrderShipperColumnComponent,
    OrderTrailerColumnComponent,
    OrderProfitColumnComponent,

    // new design
    OrderColumnComponent,
    QuoteColumnComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    CustomViewsModule,
  ]
})
export class CustomColumnsModule { }
